import "babel-polyfill"; //IE11 support
import React from "react";
import ReactDOM from "react-dom";

import { MainRoutes } from "./routes";
import "./less/main.less";

import "./index.css";
// import App from "./App";
//import * as serviceWorker from './serviceWorker';

ReactDOM.render(<MainRoutes />, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
//serviceWorker.unregister();
